var IPayPayment = (function ($, PaymentProviderBase, CheckoutSettings, PromiseUtil) {

	var IPayPayment = PaymentProviderBase.extend({

        type: 'ipay',
        paymentOption: CheckoutSettings.PaymentOption.IPay88Payments,

		initialize: function () {
			this._calbackUrl = window.location.href;
		},

		prepayment: function () {
			return this._api.redirectToIPay(this._calbackUrl);
		},

		complete: function (data) {
			return PromiseUtil.resolved(data.Value);
		},

		tryComplete: function (params) {
			if (params) {
				return this._api.paymentIPay({ postData: JSON.parse(params) });
			} else {
				return PromiseUtil.rejected();
			}
		}
	});

	return IPayPayment;
})($, PaymentProviderBase, CheckoutSettings, PromiseUtil);
